import React, { useRef, useState } from 'react';
import clsx from "clsx";
import customStyles from "../../../../../../assets/styles/customStyles";
import { Space, Modal, Row, Col, Image } from "antd";
import { Button } from "@mui/material";
import moment from 'moment';
import CloseIcon from "../../../../../../assets/images/icon_menus/Close Button.svg";
import html2pdf from "html2pdf.js";
import { currencyFormat } from "../../../../../../helpers/utilities";
import colorborder from "../../../../../../assets/images/colorborder.png";


export const ReportModal = React.forwardRef((props, ref) => {
    const { title, handleClose, open, details } = props;
    const pdfExportComponent = useRef(null);
    const [loading, setLoading] = useState(false);

    const handleDownloadNew = (type = 'download') => {
        const element = pdfExportComponent.current;
        let iv = '';
        setLoading(true);
        html2pdf().from(element).set({
            margin: [10, 5, 10, 5], // [top, left, bottom, right]
            filename: `${title}`,
            autoPaging: 'text',
            image: { type: "jpeg", quality: 1.0 },
            html2canvas: {
                scale: 3, // Increase scale for high resolution
                dpi: 300, // Ensure high DPI
                useCORS: true,
                letterRendering: true,
            }, // A4 width in pixels (≈ 210mm)
            pagebreak: { mode: ["css", "legacy"], before: '.page-break', avoid: '.no-break' },
            jsPDF: { unit: "mm", format: "a3", orientation: title === 'Product Group wise Analysis' ? 'landscape' : "portrait" },
        }).toPdf().get("pdf").then((pdf) => {
            // pdf.setFont("Roboto");
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);

                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                pdf.addImage(colorborder, "PNG", 5, 10, pageWidth - 10, pageHeight - 20); // x, y, width, height

                pdf.setFontSize(10);
                pdf.setTextColor(49, 119, 135);

                const rightTextWidth = pdf.getTextWidth(`${iv} Pg. ${i} | ${totalPages}`);
                pdf.text(`${iv} Pg. ${i} | ${totalPages}`, pageWidth - rightTextWidth - 5, pageHeight - 5);
                pdf.text('* Powered by YOUNOTE', 5, pageHeight - 5);
            }

            if (type === 'print') {
                pdf.autoPrint();
                window.open(pdf.output('bloburl', "_blank"));
            } else {
                pdf.save(`${title}`);
            }
            setLoading(false);
        });
    }

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }


    const classes = customStyles();
    return (
        <Modal title="" open={open} footer={null}
            onCancel={() => handleClose(!open)}
            width={1500}
            closable={false}
            className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
            <Row gutter={75} className={classes.invoiceHeader}>
                <Col span={24} className={clsx(classes.textAlignRight, classes.fontSize0)}>
                    <Space size={[20, 20]} direction="horizontal" align="center">
                        <Button
                            key="confirm"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownloadNew('print')}
                            className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}
                        >Print</Button>
                        <Button
                            key="save"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownloadNew()}
                            className={clsx(classes.modalBtn, { [classes.loading]: loading })}
                        >Download</Button>
                        <Image onClick={() => handleClose(!open)} src={CloseIcon} preview={false} className={classes.cursor} />
                    </Space>
                </Col>
            </Row>
            <div ref={pdfExportComponent} className={clsx(classes.divToPrint, classes.divToPrintReport)}>
                <div className={classes.downloadbars}>
                    <div className={classes.downloadtopbar}></div>
                    <div className={classes.downloadsecondbar} style={{ height: 40 }}></div>
                </div>
                <div className={clsx(classes.downloaddetails)}>
                    <Row>
                        <Col span={12} className={clsx(classes.bill, classes.thirdSection)}>
                            {
                                details?.description ? <>
                                    <p style={{ padding: 0 }} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</p>
                                    <p className={clsx(classes.textFieldColor, classes.fonSize14)}>{details?.description}</p>
                                </> : ''
                            }
                            {
                                (details?.customer || details?.supplier) && <>
                                    <h2 style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={classes.aTitle}>{details?.customer?.name || details?.supplier?.name}</h2>
                                    <p className={clsx(classes.textFieldColor, classes.fonSize14)}>{address(details?.customer || details?.supplier)}</p>
                                    <p className={clsx(classes.textFieldColor, classes.fonSize14)}>{address1(details?.customer || details?.supplier)}</p>
                                </>
                            }
                        </Col>
                        <Col span={12} className={clsx(classes.textAlignRight, classes.thirdSection)}>
                            <p style={{ padding: 0 }} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Transaction Date</p>
                            <p className={clsx(classes.textFieldColor, classes.fonSize14)}>{moment(details.transactionDate).format('DD MMM YYYY')}</p>
                        </Col>
                    </Row>
                    <div className={clsx(classes.thirdSectionReport, classes.thirdSection, classes.blackBorderTop)}>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>Cost Spend Breakdown</h4>
                        </div>
                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={5}><h6>Product Name</h6></Col>
                            <Col span={2}><h6>Product ID</h6></Col>
                            <Col span={2}><h6>Quantity</h6></Col>
                            <Col span={2}><h6>Unit cost</h6></Col>
                            <Col span={3}><h6>Total Cost</h6></Col>
                            <Col span={3}><h6>Sales Order</h6></Col>
                            <Col span={3}><h6>Sales Line</h6></Col>
                            <Col span={4}><h6>Sales Value</h6></Col>
                        </Row>
                        {
                            details?.stockAdjustmentItems?.length > 0 ? details?.stockAdjustmentItems.map((data, i) => (
                                <Row key={i} className={clsx(classes.bill, 'no-break')}>
                                    <Col span={5}><p>{data?.product?.productName || '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.product?.productId || '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.quantity || '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.pricePerUnit ? `₹ ${currencyFormat(data?.pricePerUnit || 0)}` : '---'}</p></Col>
                                    <Col span={3}><p style={{ padding: "0 5px" }}>{data?.amount ? `₹ ${currencyFormat(data?.amount || 0)}` : '---'}</p></Col>
                                    <Col span={3}><p style={{ padding: "0 5px" }}>{data?.orderDetails?.serialNo || '---'}</p></Col>
                                    <Col span={3}><p style={{ padding: "0 5px" }}>{data?.orderLineDetails?.lineNumber || '---'}</p></Col>
                                    <Col span={4}><p style={{ padding: "0 5px" }} >{data?.orderLineDetails?.amount ? `₹ ${currencyFormat(data?.orderLineDetails?.amount || 0)}` : '---'}</p></Col>
                                </Row>
                            )) : <Row className={clsx(classes.bill)}><Col span={24}>
                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</p>
                            </Col></Row>
                        }

                        {
                            details?.stockAdjustmentItems?.length > 0 &&
                            <Row className={clsx(classes.bill, 'no-break')}>
                                <Col span={7}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total:</h6></Col>
                                <Col span={2}><p style={{ padding: "0 5px" }}>{details?.stockAdjustmentItems.reduce((sum, el) => sum + (parseFloat(el.quantity) || 0), 0)}</p></Col>
                                <Col span={2}><p style={{ padding: "0 5px" }}>{`₹ ${currencyFormat(details?.stockAdjustmentItems.reduce((sum, el) => sum + (parseFloat(el.pricePerUnit) || 0), 0))}`}</p></Col>
                                <Col span={3}><p style={{ padding: "0 5px" }}>{`₹ ${currencyFormat(details?.stockAdjustmentItems.reduce((sum, el) => sum + (parseFloat(el.amount) || 0), 0))}`}</p></Col>
                                <Col span={3}></Col>
                                <Col span={3}></Col>
                                <Col span={4}><p style={{ padding: "0 5px" }} >{`₹ ${currencyFormat(details?.stockAdjustmentItems.reduce((sum, el) => sum + (parseFloat(el.orderLineDetails?.amount) || 0), 0))}`}</p></Col>
                            </Row>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
});